export enum CourierRoutes {
    Map = 'map',
    Profile = 'profile',
    Orders = 'orders',
    Notifications = 'notifications',
    PassOrder = 'pass-order',
    Chat = 'chat',
    VehicleFiles = 'vehicle-files',
    CourierFiles = 'courier-files',
}